import { Linkedin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer
      id="footer"
      data-testid="footer-section"
      className="relative z-10 py-20 lg:py-28"
    >
      <div className="section-divider mb-16 lg:mb-20" />

      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="text-xs font-semibold tracking-[0.4em] uppercase text-cyanGlow mb-6">
          OASIS Ecosystem Technology
        </p>

        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-offWhite tracking-tight leading-snug max-w-xl mx-auto">
          Building a safe space for humanity.
        </h3>

        <div className="mt-10 flex items-center justify-center gap-6">
          <a
            href="mailto:oet.founder@gmail.com"
            data-testid="footer-email-link"
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-cyanGlow transition-colors duration-300"
          >
            <Mail size={16} strokeWidth={1.5} />
            <span>oet.founder@gmail.com</span>
          </a>

          <a
            href="https://www.linkedin.com/in/anton-lysiak-oet/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-cyanGlow transition-colors duration-300"
          >
            <Linkedin size={16} strokeWidth={1.5} />
            <span>LinkedIn</span>
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5">
          <p className="text-xs text-zinc-600 tracking-wide">
            OASIS Ecosystem Technology &copy; 2026
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
